
exports.filter_operators = [
  {text:'eq', value:'eq'},
  {text:'noteq', value:'noteq'},
  {text:'gt', value:'gt'},
  {text:'gte', value:'gte'},
  {text:'lt', value:'lt'},
  {text:'lte', value:'lte'},
  {text:'beginsWith', value:'beginsWith'},
  {text:'endsWith', value:'endsWith'},
  {text:'contains', value:'contains'},
  {text:'exist', value:'exist'},
  {text:'notExist', value:'notExist'},
  {text:'in', value:'in'},
  {text:'notIn', value:'notIn'},
];